import { useEffect, useRef } from 'react';
import { IoMdSearch } from 'react-icons/io';

type SearchInputProps = {
	refetch: () => void;
	query: string;
	setQuery: React.Dispatch<React.SetStateAction<string>>;
	placeholder: string;
};

export const SearchInput = ({
	refetch,
	query,
	setQuery,
	placeholder,
}: SearchInputProps) => {
	const hasMounted = useRef(false);

	useEffect(() => {
		if (!hasMounted.current) {
			hasMounted.current = true;
			return;
		}

		const handler = setTimeout(() => {
			refetch();
		}, 500);

		return () => {
			clearTimeout(handler);
		};
	}, [query]);

	return (
		<div className="flex items-center gap-2 border border-gray-300 bg-grey-5 rounded-rounded py-1 px-2 focus-within:border-[#007aff] focus-within:shadow-lg">
			<IoMdSearch size={20} className="text-gray-500" />
			<input
				type="text"
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				placeholder={placeholder}
				className="outline-none bg-grey-5"
				data-test="search-button"
			/>
		</div>
	);
};
